<template>
  <span v-if="!editMode" @click="editHandler">
    <!-- Read mode -->
    <span>{{data}}</span>
    <sui-icon name="edit"  @click="editHandler" class="btn" color="pink"/>
  </span>
  <span v-else>
    <!-- edit mode -->
    <sui-input
      placeholder="" ref="input" v-model="value"
      maxlength="32" class="inpt"
      v-on:blur="cancelHandler"
      @keyup.enter.native="saveHandler" @keydown.esc="cancelHandler" />
<!--    <sui-button-group class="bgroup">-->
<!--      <sui-button v-if="!changed" compact basic color="grey" icon="cancel" @click="cancelHandler" class="btn"></sui-button>-->
<!--      <sui-button v-if="changed" compact basic color="pink" icon="save" @click="saveHandler" class="btn"></sui-button>-->
<!--    </sui-button-group>-->

  </span>
</template>

<script>
  export default {
    name: "EditableField",
    props: ["data"],
    data: function () {
      return {
        editMode: false,
        value: null
      }
    },
    computed: {
      changed() {
        return ((this.data || "").trim() !== ((this.value || "").trim()))
      }
    },
    methods: {
      editHandler() {
        this.value = this.data
        this.editMode = true
        this.$nextTick(() => {
          this.$refs.input.$el.children[0].focus()
          // this.$refs.input.$el.children[0].setSelectionRange(0, this.$refs.input.$el.children[0].value.length)
      })

      },
      cancelHandler() {
        this.editMode = false;
      },

      saveHandler() {
        this.editMode = false;
        if (this.changed) {
          this.$emit("change", this.value.trim())
        }
      }
    }

  }
</script>

<style scoped>
  .bgroup {
    margin-left: 10pt;
  }
  .inpt {
    width: calc(100% - 60pt)
  }

  .btn {
    margin-left: 10pt;
  }

</style>
